import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';
import InputNumber from 'antd/lib/input-number';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function AutomobiliaField({attr, additionalOptions, dataType, ...props}) {

  const formContext = useContext(FormContext);
  const { setValueByAttr, getValueByAttr } = formContext;

  const risks = formContext.getValue('risks');
  let TIV = 0;
  if (risks !== undefined) {
      risks.forEach((risk, index) => {
        if(!isNaN(risk.vehicle.agreedValue))
          TIV = TIV + risk.vehicle.agreedValue;
      });
  }
  let maxValue = TIV/4;
  maxValue = (Math.round(maxValue/100))*100;

  const previousValue = getValueByAttr(attr);

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  let attribute = formContext.metadata[attr];

  const actions = useContext(ApplicationActionsContext);
  let ariaLabel = attribute.label;
  if(!isNaN(props.value))
    props.value = (Math.round(props.value/100))*100;

  const handleBlur = (selected) => {
      actions.saveApplication();
    };

  return <InputNumber
     aria-label={ariaLabel + ': Limit amount'}
     formatter={value => {
       if(isNaN(value)){
         return '';
       }
       else{
         return  `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
       }
     }}
     max={maxValue}
     parser={value => value.replace(/\$\s?|(,*)/g, '')}
     onBlur={handleBlur}
     {...props}
 />
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

AutomobiliaField.schema = BASIC_ELEMENT_SCHEMA;